const DataTypes = { currency: "$", percent: "%", number: "" };

export { DataTypes };
